import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import AdvertiserSelector from '@/components/AllAdvertiserSelector/index.vue';
import searchMixin from '@/mixin/search';
import { deleteCreativeWhitelist, getCreativeWhitelist, saveCreativeWhitelist, updateCreativeWhitelist } from '@/api/creative/report';
import { getWhitelistReasonLabel, whitelistReasonOptions } from '@/common/creative-whitelist';

var createDefaultForm = function createDefaultForm() {
  return {
    id: 0,
    name: '',
    reason_id: '',
    reason_detail: ''
  };
};

export default {
  name: 'creative-whitelist',
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    AdvertiserSelector: AdvertiserSelector
  },
  mixins: [searchMixin],
  data: function data() {
    var _this = this;

    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: ''
      },
      pagination: {
        total: 0
      },
      list: [],
      listLoading: false,
      tableConfig: {
        'row-key': 'id'
      },
      dialog: {
        visible: false,
        loading: false,
        editing: false,
        title: '添加白名单广告主'
      },
      form: createDefaultForm(),
      whitelistReasonOptions: whitelistReasonOptions,
      advertiserConfig: {
        prop: 'name',
        params: {
          clearable: true,
          filterable: true,
          valueKey: 'name',
          style: 'width: 100%;',
          placeholder: '请输入广告主名称'
        }
      },
      formRules: {
        name: [{
          required: true,
          message: '请选择广告主',
          trigger: 'change'
        }],
        reason_id: [{
          required: true,
          message: '请选择添加原因',
          trigger: 'change'
        }],
        reason_detail: [{
          validator: function validator(rule, value, callback) {
            if (_this.form.reason_id === -1 && !String(value || '').trim()) {
              callback(new Error('请输入补充说明'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }]
      }
    };
  },

  computed: {
    formItemList: function formItemList() {
      return {
        keyword: {
          prop: 'keyword',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            filterable: true,
            valueKey: 'name',
            clearable: true,
            placeholder: '请选择广告主'
          }
        }
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '广告主ID',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'name'
      }, {
        label: '添加原因',
        prop: 'reason_id',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return getWhitelistReasonLabel(row.reason_id);
          }
        }
      }, {
        prop: 'reason-detail-cell',
        slot: 'reason-detail-cell'
      }, {
        label: '修改人',
        prop: 'admin_name'
      }, {
        label: '创建时间',
        prop: 'created_time',
        type: 'time'
      }, {
        label: '更新时间',
        prop: 'updated_time',
        type: 'time'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    }
  },
  watch: {
    $route: function $route() {
      this.renderList();
    },
    'form.reason_id': function formReason_id(value) {
      var _this2 = this;

      if (value !== -1) {
        this.form.reason_detail = '';
        this.$nextTick(function () {
          if (_this2.$refs.whitelistForm) {
            _this2.$refs.whitelistForm.clearValidate('reason_detail');
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.renderList();
  },

  methods: {
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.listLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return getCreativeWhitelist(_this3.query);

              case 4:
                response = _context.sent;

                _this3.list = _.get(response, 'data.data.list') || [];
                _this3.pagination.total = _.get(response, 'data.data.total') || 0;

              case 7:
                _context.prev = 7;

                _this3.listLoading = false;
                return _context.finish(7);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1,, 7, 10]]);
      }))();
    },
    handleAdd: function handleAdd() {
      this.dialog.editing = false;
      this.dialog.title = '添加白名单广告主';
      this.form = createDefaultForm();
      this.dialog.visible = true;
    },
    handleEdit: function handleEdit(row) {
      this.dialog.editing = true;
      this.dialog.title = '编辑白名单广告主';
      this.form = {
        id: row.id,
        name: row.name,
        reason_id: Number(row.reason_id),
        reason_detail: row.reason_detail || ''
      };
      this.dialog.visible = true;
    },
    resetDialog: function resetDialog() {
      this.form = createDefaultForm();
      this.$refs.whitelistForm && this.$refs.whitelistForm.clearValidate();
    },
    submit: function submit() {
      var _this4 = this;

      this.$refs.whitelistForm.validate(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(valid) {
          var data;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt('return');

                case 2:
                  _this4.dialog.loading = true;
                  _context2.prev = 3;
                  data = {
                    reason_id: Number(_this4.form.reason_id),
                    reason_detail: Number(_this4.form.reason_id) === -1 ? _this4.form.reason_detail.trim() : ''
                  };

                  if (!_this4.dialog.editing) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 8;
                  return updateCreativeWhitelist(_extends({ id: _this4.form.id }, data));

                case 8:
                  _context2.next = 12;
                  break;

                case 10:
                  _context2.next = 12;
                  return saveCreativeWhitelist(_extends({ name: _this4.form.name }, data));

                case 12:
                  _this4.$message.success('操作成功');
                  _this4.dialog.visible = false;
                  _context2.next = 16;
                  return _this4.renderList();

                case 16:
                  _context2.prev = 16;

                  _this4.dialog.loading = false;
                  return _context2.finish(16);

                case 19:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4, [[3,, 16, 19]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return deleteCreativeWhitelist({ id: id });

              case 2:
                _this5.$message.success('删除成功');

                if (!(_this5.list.length === 1 && Number(_this5.query.page) > 1)) {
                  _context3.next = 7;
                  break;
                }

                _this5.query.page = Number(_this5.query.page) - 1;
                _this5.$router.push({ name: _this5.$route.name, query: _this5.query });
                return _context3.abrupt('return');

              case 7:
                _context3.next = 9;
                return _this5.renderList();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  }
};